import React from 'react';
import { Card } from 'components';
import { Typography } from 'antd';
import { renderAvatar, media } from 'helpers';
import styled from 'styled-components';

const StyledCard = styled(Card)`
	&& {
		width: 100%;
		margin-right: 1em;
		box-shadow: ${({ boxShadow }) => boxShadow || '0 12px 20px 0 rgba(0, 0, 0, 0.1), 0 17px 10px 0 rgba(0, 0, 0, 0.1)'};
		cursor: pointer;
		.ant-card-body {
			padding: 0;
			padding-top: 1em;

			${media.mobile`
				> .ant-typography {
					max-width: 120px;
				}
			`}
		}
		.ant-card-cover {
			height: 150px;
			img {
				height: 100%;
				object-fit: cover;
				border-radius: 10px 10px 0 0;
			}
		}
	}
`;

export default function TutorCard({ data, onClick, height = '220px', boxShadow, ...props }) {
	const avatar = renderAvatar(data.resource.path);
	return (
		<StyledCard {...props} boxShadow={boxShadow} height={height} src={avatar} className="ta-center" onClick={() => onClick(data)}>
			<Typography.Text strong ellipsis={{ rows: 1 }}>
				{data.firstName + ' ' + data.lastName}
			</Typography.Text>
			<Typography.Paragraph ellipsis={{ rows: 1 }} className="fs-09em">
				{data.experienceSubject || '-'}
			</Typography.Paragraph>
		</StyledCard>
	);
}
